<div class="hbox" *ngIf="audioTemplateObject">
  <div class="flex-box">
    <div class="flex-heading">
      <div class="col-xs-12 list-header">
        <ul class="breadcrumb pull-left">
          <li><a routerLink="/trees/main-concerns">Main Concerns</a></li>
          <li>{{audioTemplateId ? 'Edit' : 'New'}}</li>
        </ul>
        <div class="pull-right">
          <button class="db" [disabled]="!audioTemplateForm.valid" (click)="saveAudioTemplate()">{{audioTemplateId ? 'Update' : 'Create'}}</button>
        </div>
      </div>
    </div>
    <div class="flex-content">
      <form class="col-xs-12 p-4" #audioTemplateForm="ngForm">
        <div class="col-xs-12">
          <label class="col-xs-4 mt-0">Name</label>
          <div class="col-xs-12">
            <input-text class="col-xs-7" [parseObj]="audioTemplateObject" name="name" placeholder="Name" [required]="true" [disabled]="audioTemplateId"></input-text>
          </div>
        </div>
        <div class="col-xs-12">
          <label class="col-xs-4">Type</label>
          <div class="col-xs-12">
            <input-select class="col-xs-7" [parseObj]="audioTemplateObject" name="type" placeholder="Type" [required]="true" [disabled]="audioTemplateId" [options]="audioTemplateTypeOption"></input-select>
          </div>
        </div>
        <div class="col-xs-12">
          <label class="col-xs-4">English</label>
          <div class="col-xs-12">
            <input-text class="col-xs-7" [parseObj]="audioTemplateObject.get('urlLanguageString')" name="en" placeholder="English" [required]="true"></input-text>
          </div>
        </div>
        <div class="col-xs-12">
          <label class="col-xs-4">Hindi</label>
          <div class="col-xs-12">
            <input-text class="col-xs-7" [parseObj]="audioTemplateObject.get('urlLanguageString')" name="hi" placeholder="Hindi" [required]="true"></input-text>
          </div>
        </div>
        <div class="col-xs-12">
          <label class="col-xs-4">Kannada</label>
          <div class="col-xs-12">
            <input-text class="col-xs-7" [parseObj]="audioTemplateObject.get('urlLanguageString')" name="kn" placeholder="Kannada"></input-text>
          </div>
        </div>
        <div class="col-xs-12">
          <label class="col-xs-4">Tamil</label>
          <div class="col-xs-12">
            <input-text class="col-xs-7" [parseObj]="audioTemplateObject.get('urlLanguageString')" name="ta" placeholder="Tamil"></input-text>
          </div>
        </div>
        <div class="col-xs-12">
          <label class="col-xs-12">Telugu</label>
          <div class="col-xs-12">
            <input-text class="col-xs-7" [parseObj]="audioTemplateObject.get('urlLanguageString')" name="te" placeholder="Telugu"></input-text>
          </div>
        </div>
        <div class="col-xs-12">
          <label class="col-xs-12">Malayalam</label>
          <div class="col-xs-12">
            <input-text class="col-xs-7" [parseObj]="audioTemplateObject.get('urlLanguageString')" name="ma" placeholder="Malayalam"></input-text>
          </div>
        </div>
        <div class="col-xs-12">
          <label class="col-xs-12">Bengali</label>
          <div class="col-xs-12">
            <input-text class="col-xs-7" [parseObj]="audioTemplateObject.get('urlLanguageString')" name="bn" placeholder="Bengali"></input-text>
          </div>
        </div>
        <div class="col-xs-12">
          <label class="col-xs-12">Marathi</label>
          <div class="col-xs-12">
            <input-text class="col-xs-7" [parseObj]="audioTemplateObject.get('urlLanguageString')" name="mr" placeholder="Marathi"></input-text>
          </div>
        </div>
      </form>
    </div>
  </div>
</div>
